import type { OpeningHour } from '../lib/api.js';

/// Uma faixa em edição, com o relógio que o seletor de horário usa ("09:00").
export interface OpeningHourDraft {
  weekday: number;
  start: string;
  end: string;
}

export const weekdays = [
  { value: 1, label: 'Segunda' },
  { value: 2, label: 'Terça' },
  { value: 3, label: 'Quarta' },
  { value: 4, label: 'Quinta' },
  { value: 5, label: 'Sexta' },
  { value: 6, label: 'Sábado' },
  { value: 0, label: 'Domingo' },
];

const clock = (minute: number) =>
  `${String(Math.floor(minute / 60)).padStart(2, '0')}:${String(minute % 60).padStart(2, '0')}`;
const minuteOf = (time: string) => Number(time.slice(0, 2)) * 60 + Number(time.slice(3, 5));

export function openingHourDrafts(hours: readonly OpeningHour[]): OpeningHourDraft[] {
  return hours.map((hour) => ({
    weekday: hour.weekday,
    start: clock(hour.startMinute),
    end: clock(hour.endMinute),
  }));
}

export function openingHoursOf(drafts: readonly OpeningHourDraft[]): OpeningHour[] {
  return drafts
    .map((draft) => ({
      weekday: draft.weekday,
      startMinute: minuteOf(draft.start),
      endMinute: minuteOf(draft.end),
    }))
    .sort((a, b) => a.weekday - b.weekday || a.startMinute - b.startMinute);
}

/// O que dá para conferir antes de mandar; o servidor repete a regra.
export function openingHoursError(drafts: readonly OpeningHourDraft[]): string | undefined {
  if (drafts.some((draft) => !draft.start || !draft.end))
    return 'Informe a abertura e o fechamento de cada faixa.';
  if (drafts.some((draft) => draft.start >= draft.end))
    return 'O fechamento deve ser depois da abertura.';
  const overlapping = weekdays.some(({ value }) => {
    const day = drafts
      .filter((draft) => draft.weekday === value)
      .sort((a, b) => a.start.localeCompare(b.start));
    return day.some((draft, index) => index > 0 && day[index - 1]!.end > draft.start);
  });
  return overlapping ? 'As faixas de um mesmo dia não podem se sobrepor.' : undefined;
}
